/**
 * LOCAL STORAGE KEYS
 *
 * These keys are used when handling some data
 * in the browser's localStorage API
 */

/**
 * PRINT
 */
export const PRINT_QUALITY = 'me-print-quality';
